export default Object.freeze({
  Ascending: 1,
  Descending: 2,
});
